import { render, staticRenderFns } from "./PageCoupons.vue?vue&type=template&id=1ddc1065&scoped=true&"
import script from "./PageCoupons.vue?vue&type=script&lang=ts&"
export * from "./PageCoupons.vue?vue&type=script&lang=ts&"
import style0 from "./PageCoupons.vue?vue&type=style&index=0&id=1ddc1065&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc1065",
  null
  
)

export default component.exports